<button
    mat-icon-button
    [matMenuTriggerFor]="languageMenu"
    class="flex items-center justify-center p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors min-w-[40px] relative"
    [attr.aria-label]="'Selecionar idioma' | autoTranslate"
>
    <div class="relative">
        <img
            [src]="selectedLanguageOption?.flagUrl"
            [alt]="selectedLanguageOption?.name"
            class="relative w-5 overflow-hidden rounded-sm shadow"
            [attr.data-lang]="selectedLanguage"
            (error)="onFlagError($event)"
            [class.opacity-50]="isTranslating"
        />
        <span *ngIf="showEmoji[selectedLanguage || '']" class="text-xl ms-1" [class.opacity-50]="isTranslating">{{ selectedLanguageOption?.flag }}</span>
        <!-- Spinner de loading -->
        <div
            *ngIf="isTranslating"
            class="absolute inset-0 flex items-center justify-center bg-white dark:bg-gray-800 bg-opacity-80 dark:bg-opacity-80 rounded-sm"
        >
            <mat-progress-spinner [diameter]="20" [strokeWidth]="3" [mode]="'indeterminate'"></mat-progress-spinner>
        </div>
    </div>
</button>

<mat-menu #languageMenu="matMenu">
    <button mat-menu-item *ngFor="let lang of languages" (click)="selectLanguage(lang.code)">
        <div class="flex items-center gap-3 w-full min-w-[100px]">
            <img
                [src]="lang.flagUrl"
                [alt]="lang.name"
                class="relative w-6 overflow-hidden rounded-sm shadow"
                [attr.data-lang]="lang.code"
                (error)="onFlagError($event)"
            />
            <span *ngIf="showEmoji[lang.code]" class="text-xl flex-shrink-0">{{ lang.flag }}</span>
            <span class="flex-1 text-start">{{ lang.name }}</span>
            <mat-icon *ngIf="lang.code === selectedLanguage" class="text-primary flex-shrink-0">check</mat-icon>
        </div>
    </button>
</mat-menu>
